// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__CRotG","content":"mimic___styles_content__TwSc4","divider":"mimic___styles_divider__acyEw"};